import { z } from 'zod';
import { networkBuild } from '@hoodmorning/config';

const address = z.string().regex(/^0x[0-9a-fA-F]{40}$/).refine(v => !/^0x0{40}$/i.test(v))
  .transform(v => v.toLowerCase() as `0x${string}`);
const hash = z.string().regex(/^0x[0-9a-f]{64}$/);
export const engineRecoverySelectionSchema = z.strictObject({ vault: address });
export const engineRecoveryRpcSchema = z.strictObject({ vault: address, configurationHash: hash,
  method: z.string().min(1).max(64), params: z.array(z.unknown()).max(3).optional() });
/** Read configuration only. No release, installation or signing capability. */
const runtimeShape = {
  schemaVersion: z.literal(1), chainId: z.literal(4663), userId: z.string().min(1).max(128),
  owner: address, vault: address, configurationHash: hash,
  conditional: z.boolean(), external: z.boolean(),
  policy: z.strictObject({ maxRequests: z.number().int().min(16).max(512),
    maxDurationMs: z.number().int().min(1).max(30000),
    maxAgeSeconds: z.number().int().min(1).max(3600), maxFutureSeconds: z.number().int().min(0).max(60) }),
  requestTimeoutMs: z.number().int().min(1).max(8000), requiredConfirmations: z.number().int().min(2).max(256),
  signingAuthorized: z.literal(false), submissionAuthorized: z.literal(false), executionAuthorized: z.literal(false),
};
export const engineRecoveryRuntimeSchema = z.strictObject(runtimeShape)
  .refine(v => (v.conditional || v.external) && v.requestTimeoutMs <= v.policy.maxDurationMs);
/** Selected external recovery only. Legacy conditional setup is not converted. */
export const selectedEngineRecoveryRuntimeSchema = z.strictObject({ ...runtimeShape,
  chainId: z.literal(networkBuild.chainId), conditional: z.literal(false), external: z.literal(true) })
  .refine(v => v.requestTimeoutMs <= v.policy.maxDurationMs);
export type EngineRecoveryRuntime = z.infer<typeof engineRecoveryRuntimeSchema>;

export type SelectedEngineRecoveryRuntime = z.infer<typeof selectedEngineRecoveryRuntimeSchema>;
